import {
  decorate,
  observable,
  action,
  runInAction,
} from 'mobx'

import AsyncStoreBase from '~src/store/AsyncStoreBase'
import Api from './errors.api'

class ErrorsStore extends AsyncStoreBase {
  constructor () {
    super()

    runInAction(() => {
      this.errors = []
    })
  }

  log = async (...params) => {
    try {
      this.setBusy(true)
      this.setError()
      const { status } = await Api.log(...params)
      this.setSuccess(!!status && status === 200)

      this.setBusy(false)
    } catch (err) {
      this.setError(err)
      this.setBusy(false)
    }
  }

}

decorate(ErrorsStore, {
  errors: observable,
  log: action
})

export default new ErrorsStore()
